import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage, intlShape } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { CTAButton } from 'shared-components/buttons/cta-button';
import RadioButtonWithSubLabel from '../../app-main/components/reduxForms/fields/RadioButtonField/RadioButtonWithSubLabel';
import { Spinner } from 'shared-components/decorators/spinner';
import { getBufferTimeSetting, setBufferTimeSetting } from '../../../../api/api-calendar';

class BufferTime extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      bufferTimeValue: null,
      error: false,
      isLoading: true,
      submitting: false
    };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.saveBufferTimeSelection = this.saveBufferTimeSelection.bind(this);
    this.onChangeRadio = this.onChangeRadio.bind(this);
  }

  componentDidMount () {
    const { accessToken, spaceId } = this.props;
    this.setState({ isLoading: false });
    getBufferTimeSetting(spaceId, accessToken, (res)=>{
      const newState = { isLoading: false, bufferTimeValue: res?.buffer_time?.toString() || '0' };
      this.setState(newState);
    });
  }

  saveBufferTimeSelection () {
    const { accessToken, spaceId, spaceObject } = this.props;
    if (!accessToken || !spaceId) {
      return this.setState({ error: true });
    }
    const payload = { buffer_time: parseInt(this.state.bufferTimeValue, 10) };
    setBufferTimeSetting(spaceId, accessToken, payload, (data)=>{
      if (data.error) return this.setState({ error: true });
      const bufferTimeConverter = {
        0: 'no buffer time',
        30: '30 min',
        60: '1 hr',
        120: '2 hr'
      };
      const properties = {
        spaceId,
        time: bufferTimeConverter[this.state.bufferTimeValue],
        bufferTimeActive: 0 < parseInt(this.state.bufferTimeValue),
        hostId: this.props.SSOid,
        deviceType: this.props.deviceType,
        metro: spaceObject.metro

      };
      analyticsIntegrations.bufferTimeSaveBtnClicked(properties);
      this.props.toggleBlockDayModal();
    });
  }

  handleFormSubmit (e) {
    e.preventDefault();
    this.setState({ submitting: true }, this.saveBufferTimeSelection);
  }

  onChangeRadio (e) {
    if (e.currentTarget && e.currentTarget.value) {
      this.setState({ bufferTimeValue: e.currentTarget.value });
    }
  }

  render () {
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();
    const options = [
      {
        key: 'no-buffer-time',
        value: '0',
        label:
            <FormattedMessage
              id="hosting.calendar_main.buffer_time_modal_no_time_btn"
              defaultMessage="No buffer time"
            />,
        sublabel:
            <FormattedMessage
              id="hosting.calendar_main.buffer_time_modal_no_time_btn_copy"
              defaultMessage="No time will be blocked out between bookings"
            />
      },
      {
        key: '30-min',
        value: '30',
        label:
            <FormattedMessage
              id="hosting.calendar_main.buffer_time_modal_30_min_btn"
              defaultMessage="30 min"
            />,
        sublabel:
            <FormattedMessage
              id="hosting.calendar_main.buffer_time_modal_30_min_btn_copy"
              defaultMessage="30 minutes will be blocked out between bookings"
            />
      },
      {
        key: '60-min',
        value: '60',
        label:
            <FormattedMessage
              id="hosting.calendar_main.buffer_time_modal_1_hr_btn"
              defaultMessage="1 hr"
            />,
        sublabel:
            <FormattedMessage
              id="hosting.calendar_main.buffer_time_modal_1_hr_btn_copy"
              defaultMessage="1 hour will be blocked out between bookings"
            />
      },
      {
        key: '120-min',
        value: '120',
        label:
            <FormattedMessage
              id="hosting.calendar_main.buffer_time_modal_2_hr_btn"
              defaultMessage="2 hr"
            />,
        sublabel:
            <FormattedMessage
              id="hosting.calendar_main.buffer_time_modal_2_hr_btn_copy"
              defaultMessage="2 hours will be blocked out between bookings"
            />
      }
    ];

    const inputProps = (value) => {
      const input = {
        name: 'bufferTime',
        type: 'radio',
        value,
        id: `buffer-time-${value}`,
        onChange: this.onChangeRadio
      };
      return input;
    };
    return (
      <BootstrapModal
        showModal={this.props.showModal}
        modalClass="buffer-time-modal"
        headerClass="padding-no-top padding-md-bottom"
        bodyClass="padding-no-top"
        onClose={this.props.toggleBlockDayModal}
        header={
          <div>
            <div className="margin-lg-bottom">
              <h3>
                <FormattedMessage
                  id="hosting.calendar_main.buffer_time"
                  defaultMessage="Buffer time"
                />
              </h3>
            </div>
            <p className="padding-xl-left padding-xl-right">
              <FormattedMessage
                id="hosting.calendar_main.buffer_time_modal_copy"
                defaultMessage="Have time to prep for your next guest by automatically blocking out time between each booking."
              />
            </p>
          </div>
        }
        body={this.state.isLoading ? (<div>
          <Spinner additionalStyle="gray" />
        </div>) : (
          <form onSubmit={this.handleFormSubmit}>
            {
              options.map((option) => {
                const currentlySelectedRadioBtn = this.state.bufferTimeValue === option.value;
                return (
                  <RadioButtonWithSubLabel
                    key={option.key}
                    input={inputProps(option.value)}
                    addtionalClasses={currentlySelectedRadioBtn ? 'border-gray-900' : ''}
                    currentlySelected={currentlySelectedRadioBtn}
                    displayTitle={option.label}
                    displayText={option.sublabel}
                  />
                );
              })
            }
            <CTAButton
              onClickAction={this.handleFormSubmit}
              classNameString="btn classic btn-primary btn-block form-submit-btn"
              isDisabled={false}
              spinning={this.state.submitting}
              buttonText={
                <FormattedMessage
                  id="hosting.calendar_main.buffer_time_save"
                  defaultMessage="Save"
                />
              }
            />
            {
              this.state.error &&
                      <div className="text-danger text-small text-center margin-sm-top">
                        <FormattedMessage
                          id="hosting.calendar_main.buffer_time_modal_error_message"
                          defaultMessage="We were unable to save any changes. Please refresh or try again later."
                        />
                      </div>
            }
            <div className="sub-label text-center margin-lg-top padding-xl-left padding-xl-right">
              <FormattedMessage
                id="hosting.calendar_main.buffer_time_modal_footer_copy"
                defaultMessage="Once saved, your chosen buffer time amount will be applied to all future bookings until turned off or changed. {learnMore}"
                values={{
                  learnMore:
                              <a href={`https://support.peerspace.com/hc/${zendeskLocale}`} className="underline">
                                <FormattedMessage
                                  id="hosting.calendar_main.buffer_time_modal_footer_link"
                                  defaultMessage="Learn more"/>
                              </a>
                }}
              />
            </div>
          </form>)
        }
      />
    );
  }
}

export default BufferTime;

BufferTime.propTypes = {
  showModal: PropTypes.bool,
  toggleModal: PropTypes.func,
  intl: intlShape.isRequired
};
